var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlobs01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B1DBB4;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.4,171c-0.9,22.8-6.4,42.6-13.3,62c-18.2,51.3-36.4,102.7-54.6,154c-7.1,20-15.5,39.5-27.8,56.9 c-21.8,31-53.1,43.6-88.4,35.6c-37.8-8.5-62.4-30.7-70-69.6c-2.9-14.8-4.8-29.9-7.7-44.7c-4.9-25.5-21.2-39.9-46-45.5 c-12.4-2.8-24.9-5.1-37.1-8.6c-17.3-4.9-30.7-14.9-34.7-33.5c-4.2-19.2,3.9-34.3,17.9-46.7c4.1-3.6,8.6-6.7,13-9.9 c33.8-25.2,54-58,58.3-100.4c1.7-16.8,3.9-33.6,9.3-49.9c7.8-23.5,24.2-39,46.2-48.4c26-11.2,54.4-0.4,61.9,26.6 c12.1,43.7,39.8,60.7,83.2,58.8c12.6-0.6,25.4,1.4,37.9,3.6C422.4,117.2,440.5,139.1,440.4,171z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobs01);
export default __webpack_public_path__ + "static/media/blobs-01.8668f478a821e93f9139cafaee5311c5.svg";
export { ForwardRef as ReactComponent };